import { Component, Prop, Vue } from 'vue-property-decorator'
import { OrderModel } from '../models/OrdersViewModel';
import ProgressContainer from "./progressContainer";

@Component({
    name: 'order-info-component',
    template: '#order-info-component',
    components: { ProgressContainer }
})
export default class OrderInfo extends Vue {
    // define prop
    @Prop({})
    order: OrderModel;

    @Prop({})
    isDownloading: Boolean;

    @Prop({})
    isCreditNoteDownloading: Boolean;

    getInvoice() {
        this.$emit('getInvoice');
    }

    getCreditNote() {
        this.$emit('getCreditNote');
    }
}